import { Component, Prop, h } from '@stencil/core';
import state from '@ugc-store';
import { getQuestionAnswers, postSeeMoreAnswersMetrics } from '@ugc-api/question';
import { getThumbStatus } from '@ugc-api/helpful-status';
import { IQuestionInfo } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';
import { toAnswerInfoList } from '@ugc-components/ugc-pdp-question-and-answer/utils';
import View from './view';

@Component({
  tag: 'ugc-question-and-answer',
  shadow: false,
})
export class UgcQuestionAndAnswer {
  @Prop() questionListItem: IQuestionInfo;

  async handleViewMoreAnswers() {
    const {
      productInfo: { productId },
      isLogin,
    } = state;
    const { id: questionId = '' } = this.questionListItem || {};

    try {
      const { items: answers = [], nextPageToken } = ((await getQuestionAnswers(productId, questionId)) as any) || {};
      const { aids, answersBreakUpById } = toAnswerInfoList(answers);
      try {
        if (isLogin) {
          const data = await getThumbStatus(aids); // get vote status
          if (data && data.length) {
            data.forEach(({ id, vote }) => {
              if (answersBreakUpById[id]) {
                answersBreakUpById[id].hasThumbsUp = vote;
              }
            });
          }
        }
      } catch (e) {}

      state.isShowViewMoreAnswersModal = true;
      state.viewMoreAnswersData = {
        questionId,
        nextPageToken,
        answersIdList: aids,
        answersDetail: answersBreakUpById,
      };
      postSeeMoreAnswersMetrics(questionId);
    } catch (e) {}
  }

  render() {
    return (
      <View questionListItem={this.questionListItem} handleViewMoreAnswers={this.handleViewMoreAnswers.bind(this)} />
    );
  }
}
